<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Por vendedor por IPT
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Máquinas</span>
      <span> /</span>
      <span class="grey-text">Reportes</span>
      <span> /</span>
      <span>Por vendedor por IPT</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="row filtros-body">
      <div class="col" style="max-width: 200px">
        <div class="md-form">
          <input
            value=""
            type="text"
            id="rutVend"
            class="form-control"
            placeholder="Código del vendedor"
            required
            #rutVend
          />
          <label for="rutVend">Código del vendedor</label>
        </div>
      </div>
      <div class="col" style="width: 50px">
        <button
          mdbBtn
          type="button"
          class="btn-cuadrado"
          color="secondary"
          mdbWavesEffect
          (click)="seleccionarProveedor.show()"
        >
          <mdb-icon fas icon="search"></mdb-icon>
        </button>
      </div>
    </div>

    <h5 style="border-bottom: 1px solid #dee2e6">IPT</h5>

    <div class="row filtros-body">
      <div class="col" style="max-width: 150px">
        <mdb-checkbox [checked]="true">Lunes</mdb-checkbox>
      </div>
      <div class="col" style="max-width: 150px">
        <mdb-checkbox [checked]="false"
          ><span style="font-size: 1rem">Martes</span></mdb-checkbox
        >
      </div>
      <div class="col" style="max-width: 150px">
        <mdb-checkbox [checked]="false"
          ><span style="font-size: 1rem">Miercoles</span></mdb-checkbox
        >
      </div>
      <div class="col" style="max-width: 150px">
        <mdb-checkbox [checked]="false"
          ><span style="font-size: 1rem">Jueves</span></mdb-checkbox
        >
      </div>
      <div class="col" style="max-width: 150px">
        <mdb-checkbox [checked]="false"
          ><span style="font-size: 1rem">Viernes</span></mdb-checkbox
        >
      </div>
      <div class="col" style="max-width: 150px">
        <mdb-checkbox [checked]="false"
          ><span style="font-size: 1rem">Sábado</span></mdb-checkbox
        >
      </div>
      <div class="col" style="max-width: 150px">
        <mdb-checkbox [checked]="false"
          ><span style="font-size: 1rem">Domingo</span></mdb-checkbox
        >
      </div>
      <div class="col" style="max-width: 150px">
        <mdb-checkbox [checked]="false"
          ><span style="font-size: 1rem">Todos</span></mdb-checkbox
        >
      </div>
    </div>
  </div>
  <!-- FOOTER -->
  <div
    class="card-footer text-muted filtros-footer"
    style="border-top: 1px solid #dee2e6"
  >
    <div></div>
    <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect>
      <mdb-icon fas icon="search"></mdb-icon>
      Buscar
    </button>
  </div>
</div>

<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Cliente</th>
            <th scope="col">Marca</th>
            <th scope="col">N° Placa</th>
            <th scope="col">Modelo</th>
            <th scope="col">Estado</th>
            <th scope="col">IPT</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>VICTOR TORREJON</td>
            <td>MIMET</td>
            <td>513245</td>
            <td>CV-350</td>
            <td><mdb-badge pill="true" success="true">Buena</mdb-badge></td>
            <td>Martes</td>
          </tr>
          <tr>
            <td>VICTOR TORREJON</td>
            <td>MIMET</td>
            <td>513245</td>
            <td>CV-350</td>
            <td><mdb-badge pill="true" success="true">Buena</mdb-badge></td>
            <td>Martes</td>
          </tr>
          <tr>
            <td>VICTOR TORREJON</td>
            <td>MIMET</td>
            <td>513245</td>
            <td>CV-350</td>
            <td><mdb-badge pill="true" success="true">Buena</mdb-badge></td>
            <td>Martes</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="card mb-2 wow">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn type="button" color="success" mdbWavesEffect class="btn">
      Imprimir
    </button>
  </div>
</div>

<!-- MODAL seleccionarProveedor -->
<div
  mdbModal
  #seleccionarProveedor="mdb-modal"
  class="modal fade"
  id="basicExample"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Seleccionar proveedor
        </h4>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="seleccionarProveedor.hide()"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col">
            <div class="md-form">
              <input
                value=""
                type="text"
                id="rutVend"
                class="form-control"
                placeholder="Nombre o RUT del vendedor"
                required
                #rutVend
              />
              <label for="rutVend">Nombre o RUT del vendedor</label>
            </div>
          </div>
          <div class="col" style="width: 50px">
            <button
              mdbBtn
              type="button"
              class="btn-cuadrado"
              color="secondary"
              mdbWavesEffect
              (click)="seleccionarProveedor.show()"
            >
              <mdb-icon fas icon="search"></mdb-icon>
            </button>
          </div>
        </div>
        <table class="table table-striped table-hover table-sm align-middle">
          <thead class="grey lighten-2">
            <tr>
              <th scope="col" class="text-center">RUT</th>
              <th scope="col" class="text-center">Nombre</th>
              <th scope="col" class="text-center">Sucursal</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>99.999.999-9</td>
              <td>Nombre vendedor</td>
              <td>Matriz</td>
              <td>
                <button
                  mdbBtn
                  type="button"
                  color="indigo"
                  mdbWavesEffect
                  class="btn"
                  size="sm"
                  (click)="seleccionarProveedor.hide()"
                >
                  Seleccionar
                </button>
              </td>
            </tr>
            <tr>
              <td>99.999.999-9</td>
              <td>Nombre vendedor</td>
              <td>Matriz</td>
              <td>
                <button
                  mdbBtn
                  type="button"
                  color="indigo"
                  mdbWavesEffect
                  class="btn"
                  size="sm"
                  (click)="seleccionarProveedor.hide()"
                >
                  Seleccionar
                </button>
              </td>
            </tr>
            <tr>
              <td>99.999.999-9</td>
              <td>Nombre vendedor</td>
              <td>Matriz</td>
              <td>
                <button
                  mdbBtn
                  type="button"
                  color="indigo"
                  mdbWavesEffect
                  class="btn"
                  size="sm"
                  (click)="seleccionarProveedor.hide()"
                >
                  Seleccionar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
